import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { BoldSubtitle, Subtitle } from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";
import { Favicon } from "@similarweb/ui-components";
import { SegmentFavicon } from "pro-features/components/Chart/src/dataLabels/favicon/SegmentFavicon";

interface ITooltipTitle {
    favicon: string;
    entityDisplayName: string;
    subtitle?: string;
}

export const TooltipTitle = ({ entityDisplayName, favicon, subtitle }: ITooltipTitle) => {
    return (
        <FlexRow gap={"8px"}>
            {subtitle ? (
                <SegmentFavicon
                    src={favicon}
                    margins={{ top: "1px", left: "1px" }}
                />
            ) : (
                <Favicon src={favicon} />
            )}
            <FlexColumn gap={"2px"}>
                <BoldSubtitle>{entityDisplayName}</BoldSubtitle>
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </FlexColumn>
        </FlexRow>
    );
};
